import React from "react";

// React Router
import { Switch, Redirect } from "react-router-dom";
import { PrivateRoute } from "./routes";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function AppRouter(props) {
  return (
    <React.Fragment>
      {/* <Header path={props.location.pathname} /> */}

      <div className="app-container">
        <Switch>
          {/* <Redirect exact from="/" to="/stations" />
          <PrivateRoute path="/stations" component={Stations} /> */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

export default AppRouter;
